export const profileSyncEducationItem = {
    templateUrl: Evisors.config.cdnRootWhitelabel + 'asset/partials/user/components/profileSyncEducationItem.html',
    bindings: {
        item: '<',
        hl: '<',
    },
};
